<a href="https://support.decathlon.net/saw/ess/offeringPage/162910569"
	 target="_blank"
	 rel="noopener noreferrer">
	<span>{{ 'REPORTISSUES.DESCRIPTION' | translate }}</span>
</a>
